import { CurrentAccessLegalEntityDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCurrentAccessLegalEntity = () => {
  const { loading, data } = useQuery(CurrentAccessLegalEntityDocument)

  const legalEntity = data?.apiCore.currentsConnection.nodes[0]?.employee?.legalEntity

  return {
    loading,
    legalEntity,
  }
}
